import React from "react";
import PageLayout from '../../Components/PageLayout';
function Tab() {
    return (
        <PageLayout title="Tab" subtitle="Tab overview">
            <div className="container flex col box-container">
                {/* <div className="box">Tab</div>
                <div className="box">Tab</div>
                <div className="box">Tab</div> */}
            </div>
        </PageLayout>
    );
}

export default Tab;
